import { ActionsObservable, combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, pluck, startWith } from 'rxjs/operators'

import * as serviceApi from 'api/report/service'
import { EXPORT_FUNCTON_FOR_METRIC } from 'api/report/service/exporters'
import * as OrgSelectors from 'modules/org/selectors'
import { fromRequest } from 'utils/api'
import { csvFilenameFromQuery } from 'utils/csv'
import { selectState } from 'utils/redux'

import * as actions from './actions'

const fetchServiceData = (action$: ActionsObservable<any>) => {
  return action$.pipe(
    ofType(actions.fetchServiceData.toString()),
    pluck('payload'),
    mergeMap(({ queryConfig, options }) => {
      return fromRequest(
        serviceApi.fetchSimpleReport(queryConfig, options)
      ).pipe(
        mergeMap((response) => [
          actions.fetchServiceDataSuccess({ queryConfig, response }),
        ]),
        startWith(actions.fetchServiceDataPending(queryConfig)),
        catchError((error) => {
          console.error(error)
          return of(actions.fetchServiceDataFailed({ queryConfig, error }))
        })
      )
    })
  )
}

const exportServiceData = (action$, state$) =>
  action$.pipe(
    ofType(actions.exportServiceData.toString()),
    pluck('payload'),
    mergeMap(({ queryConfig, options }) => {
      return fromRequest(
        serviceApi.fetchSimpleReport(queryConfig, options)
      ).pipe(
        map((response) => {
          const orgUsers = OrgSelectors.unfilteredOrgUsersById(state$.value)
          const classifications = selectState(state$.value, 'classifications')
          const exportCSV = EXPORT_FUNCTON_FOR_METRIC[queryConfig.metric]
          exportCSV(
            response,
            orgUsers,
            csvFilenameFromQuery(queryConfig),
            classifications
          )
          return actions.exportServiceDataSuccess({
            queryConfig,
            response,
          })
        }),
        catchError((error) => {
          console.error('Error while exporting CSV: ', error)
          return of(actions.exportServiceDataFailed({ queryConfig, error }))
        })
      )
    })
  )

export default combineEpics(fetchServiceData, exportServiceData)
